import { render } from "./ChamadosPorCategoria.vue?vue&type=template&id=0fb3755a"
import script from "./ChamadosPorCategoria.vue?vue&type=script&lang=js"
export * from "./ChamadosPorCategoria.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__